import {
  ComponentPropsWithoutRef,
  ReactElement,
  useEffect,
  useRef,
} from 'react';

import { styled } from '@mui/material';
import { type SetRequired } from 'type-fest';

const StyledForm = styled('form')({
  borderRadius: '8px',
  overflow: 'auto',
  backgroundColor: '#fff',
  boxShadow: '0px 2px 8px 0px rgba(78, 80, 84, 0.16)',
});

type FormLayoutProps = SetRequired<
  ComponentPropsWithoutRef<typeof StyledForm>,
  'onSubmit'
>;

export const FormLayout = (props: FormLayoutProps): ReactElement => {
  const formRef = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    if (formRef.current === null) return;
  }, [formRef]);

  return <StyledForm noValidate {...props} ref={formRef} />;
};
